import Storage from './storage';

const storage = Storage('session');
function urlWithRoutingCompany(url) {
    if(url == '') return url;
    url = url.charAt(0) === '/' ? url : `/${url}`;
    const company = storage.get('company');
    return company ? `/company/${company.name}${url}` : url;
}

export default urlWithRoutingCompany;